/*
 * 100k-Aktion landing page (sections/aktion-100k-landing.liquid): animates opening and closing
 * the FAQ <details>. Without this script, or with reduced motion, they toggle instantly.
 * The click listener is delegated, so items re-rendered by the theme editor keep working.
 */
(() => {
  if (window.lp100kFaqReady) return;
  window.lp100kFaqReady = true;

  const DURATION = 350;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const running = new WeakMap();

  // Animates the height of the whole item between its closed and open height, so paddings and
  // the answer's negative margin never change mid-animation. The answer only fades.
  function toggle(details, answer) {
    const current = running.get(details);
    const opening = current ? !current.opening : !details.open;
    const startHeight = details.getBoundingClientRect().height;
    const startOpacity = details.open ? getComputedStyle(answer).opacity : '0';

    if (current) {
      current.height.cancel();
      current.fade.cancel();
    }

    details.open = false;
    const closedHeight = details.getBoundingClientRect().height;
    details.open = true;
    const openHeight = details.getBoundingClientRect().height;

    // Switches the icon right away instead of when closing has finished.
    details.classList.toggle('is-closing', !opening);
    details.style.overflow = 'hidden';

    const options = { duration: DURATION, easing: EASING, fill: 'forwards' };
    const height = details.animate(
      [{ height: `${startHeight}px` }, { height: `${opening ? openHeight : closedHeight}px` }],
      options
    );
    const fade = answer.animate([{ opacity: startOpacity }, { opacity: opening ? 1 : 0 }], options);
    running.set(details, { height, fade, opening });

    height.onfinish = () => {
      running.delete(details);
      if (!opening) details.open = false;
      details.classList.remove('is-closing');
      details.style.overflow = '';
      height.cancel();
      fade.cancel();
    };
  }

  document.addEventListener('click', (event) => {
    if (reduceMotion.matches) return;

    const summary = event.target.closest('.lp100k__faq-question');
    if (!summary) return;
    const details = summary.parentElement;
    const answer = details.querySelector('.lp100k__faq-answer');
    if (!answer) return;

    event.preventDefault();
    toggle(details, answer);
  });
})();
